import pagesJson from '@/pages.json'

/** pages.json 中单个页面的通用结构：至少有 path，其余字段（needLogin 等）不固定 */
export type PageItem = { path: string } & Record<string, any>

interface SubPackageItem {
  root: string
  pages: PageItem[]
}

interface TabBarConfig {
  list: { pagePath: string }[]
}

interface PagesJson {
  pages: PageItem[]
  subPackages?: SubPackageItem[]
  tabBar?: TabBarConfig
}

/**
 * pages.json 是编译期按当前平台生成的：h5 端没有 tabBar / subPackages 节点。
 * 对不存在的 JSON 键做 ESM 具名导入会在模块链接阶段直接报错（整条 @/utils 链路挂掉、页面白屏），
 * 故统一走默认导入再解构兜底；类型也不依赖当前生成态，两端 type-check 结果一致。
 */
const config = pagesJson as PagesJson

export const pages: PageItem[] = config.pages
export const subPackages: SubPackageItem[] = config.subPackages ?? []
export const tabBar: TabBarConfig | undefined = config.tabBar
